import { TextField, type TextFieldProps } from "@mui/material";
import { forwardRef } from "react";

/** Stateless input: the caller supplies decimal or angle validation feedback. */
export const MeasurementTextField = forwardRef<HTMLDivElement, TextFieldProps>(
	function MeasurementTextField(props, ref) {
		return (
			<TextField
				{...props}
				ref={ref}
				type="text"
				slotProps={{
					...props.slotProps,
					htmlInput: (ownerState) => ({
						inputMode: "decimal",
						...(typeof props.slotProps?.htmlInput === "function"
							? props.slotProps.htmlInput(ownerState)
							: props.slotProps?.htmlInput),
						"data-m1-measurement": true,
					}),
				}}
			/>
		);
	},
);
